/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Container, Stack, TextField, IconButton, FormControl, Checkbox, FormHelperText } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import Page from '../../../Page';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Button from '@material-ui/core/Button';
import { ToastContainer } from 'react-toastify';
import MenuItem from '@material-ui/core/MenuItem';
import Card from '@material-ui/core/Card';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import { makeStyles } from '@material-ui/styles';
import Paper from '@material-ui/core/Paper';
import TokenDecoder from 'src/helpers/TokenDecoder';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import _ from 'lodash';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import SearchNotFound from '../../../SearchNotFound';
import services from '../Service';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types'
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import { CardContent } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import xlsx from 'json-as-xlsx';
import CreatePDF from './CreatePDF';
import ReactToPrint from "react-to-print";
import Typography from '@material-ui/core/Typography';
import Scrollbar from 'src/components/Scrollbar';
import moment from 'moment';
import Chip from '@material-ui/core/Chip';
import { date } from 'faker/lib/locales/az';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import InputAdornment from '@material-ui/core/InputAdornment';
import ClearIcon from '@mui/icons-material/Clear';
import { SecurityUpdateWarningSharp } from '@mui/icons-material';


function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

var screenCode = "VCCACTIVITYREPORT"

export default function VCCOrderReportView(props) {
    const componentRef = useRef();
    const navigate = useNavigate();
    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: true,
        pageheadername: 'FCC Activity Report'
    });

    const [datevalue, setDateValue] = useState(new Date());
    const [groupList, setGroupList] = useState([]);
    const [operationEntityList, setOperationEntityList] = useState([]);
    const [csvHeaders, SetCsvHeaders] = useState([]);
    const [isHidden, setIsHidden] = useState(false);
    const [vccOrderDetails, setVccOrderDetails] = useState([]);
    const [isEnable, setIsEnable] = useState(true);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [cropData, setCropData] = useState({
        farmerName: ''
    });
    const [formData, setFormData] = useState({
        groupID: '',
        operationEntityID: '',
        date: null
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupID: '',
        operationEntityID: '',
        date: ''
    });

    const useStyles = makeStyles({
        root: {
            width: '100%',
            overflowX: 'auto'
        },
    });

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    const classes = useStyles();

    const farmerOnboardingReportSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group required'),
        operationEntityID: Yup.array()
            .min(1, 'Please select at least one Fresh collection center')
            .required('Please select at least one Fresh collection center'),

    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: selectedOptions,
            date: formData.date
        },

        validationSchema: farmerOnboardingReportSchema,
        onSubmit: (values) => {
            trackPromise(SubmitForm(values));
            setIsHidden(true)
        }
    });

    async function SubmitForm(values) {

        let model = {
            groupID: parseInt(values.groupID),
            operationEntityID: selectedOptions.map(x => x).join(',').toString(),
            orderDate: datevalue == null ? null : new Date(datevalue)
        }
        var res = await services.GetVccOrderReportDetails(model)
        setVccOrderDetails(res)
        getSelectedDropdownValuesForReport();
    }

    const { errors, setValues, touched, handleSubmit, getFieldProps, values } = formik;

    async function clearAll() {
        setVccOrderDetails([]);
        setDateValue(new Date());
        setValues({
            ...values,
            operationEntityID: 0
        })
        if (permissionList.isGroupFilterEnabled) {
            setSelectedOptions([])
        }
    }

    async function GetAllGroups() {
        let res = await services.GetAllGroupsForDropDown();
        if (res != null) {
            setGroupList(res);
        }
    }

    async function GetOperationEntityByGroupID() {
        let res = await services.GetVCCFactoriesByGroupID(formik.values.groupID);
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].factoryName, value: res[i].factoryID })
            }
            setOperationEntityList(newOptionArray);
        }
    }
    useEffect(() => {
        getPermissions();
    }, [])

    useEffect(() => {
        GetAllGroups();
    }, []);

    useEffect(() => {
        setVccOrderDetails([]);
    }, [formik.values.operationEntityID]);

    useEffect(() => {
        setVccOrderDetails([]);
    }, [datevalue]);

    useEffect(() => {
        setVccOrderDetails([]);
    }, [selectedOptions]);

    useEffect(() => {
        trackPromise(GetOperationEntityByGroupID());
    }, [formik.values.groupID]);

    useEffect(() => {
        setValues({
            ...values,
            operationEntityID: selectedOptions
        })
    }, [selectedOptions]);

    useEffect(() => {
        const factoryValue = parseInt(TokenDecoder.getGroupFactoryToken().factory);
        const selectedOptions = [factoryValue];
        setSelectedOptions(selectedOptions)
    }, [operationEntityList]);

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const handleSelectChange = (event) => {
        const selectedValues = event.target.value;

        if (selectedValues.includes('')) {
            setSelectedOptions(
                selectedOptions.length === operationEntityList.length
                    ? []
                    : operationEntityList.map((option) => option.value)
            );
        } else {
            setSelectedOptions(selectedValues);
        }
    };

    const handleClearSelection = () => {
        setSelectedOptions([]);
    };

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - vccOrderDetails.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWVCCACTIVITYREPORT');

        if (isAuthorized === undefined) {
            navigate('/404');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group)
        })
        trackPromise(GetAllGroups());

    }

    //Print
    async function createFile() {
        var file = await createDataForExcel(vccOrderDetails);
        var settings = {
            sheetName: 'FCC Activity Report',
            fileName: 'FCC Activity Report - ' + selectedSearchValues.date,
            writeOptions: {}
        }
        let keys = Object.keys(file[0])
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem })
        })
        let dataA = [
            {
                sheet: 'FCC Activity Report',
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }


    async function createDataForExcel(array) {
        var res = [];
        if (array != null) {
            array.map(x => {
                x.farmers.map(y => {
                    y.details.map(z => {
                        var vr = {
                            'FCC': x.orderReport.productName == null ? '-' : x.orderReport.collectionCenter,
                            'Product Name': x.orderReport.productName == null ? '-' : x.orderReport.productName,
                            'Product Code': x.orderReport.productCode == null ? '-' : x.orderReport.productCode,
                            'Realized Price': x.orderReport.realizedPrice == null ? '-' : x.orderReport.realizedPrice.toFixed(2),
                            'Requested Qty': x.orderReport.quantity == null ? '-' : x.orderReport.quantity.toFixed(2),
                            'Accepted Qty': x.orderReport.acceptedQuantity == null ? '-' : x.orderReport.acceptedQuantity.toFixed(2),
                            'Remaining Qty': x.orderReport.reaminingQuantity == null ? '-' : x.orderReport.reaminingQuantity.toFixed(2),
                            'Returned Qty': x.orderReport.returnQuantity == null ? '-' : x.orderReport.returnQuantity.toFixed(2),
                            'Farmer Name': y.farmerName == null ? '-' : y.farmerName,
                            'Crop Variety': z.varietyName == null ? '-' : z.varietyName,
                            'Farmer Accepted Qty': y.farmerQuantity == null ? '-' : y.farmerQuantity.toFixed(2),
                            'Accepted Time': z.acceptedDate == null ? '-' : moment(z.acceptedDate).format('h:mm:ss a'),
                            'Operator': y.operatorName == null ? '-' : y.operatorName,
                            'Tag Number': z.tagNumber == null ? '-' : z.tagNumber,
                            'Tag Count': z.tagCount == 0 ? '-' : z.tagCount,
                            'Actual Qty': z.actualAmount == null ? '-' : z.actualAmount,
                            'Gross Qty': z.grossAmount == null ? '-' : z.grossAmount,
                            'Deduction': z.deduction == null ? '-' : z.deduction,
                            'Net Qty': z.netAmount == null ? '-' : z.netAmount,
                            'Total Qty': z.totalAmount == null ? '-' : z.totalAmount,
                            'Weighment Time': new Date(z.weighReadTime).getFullYear() == 1 ? '-' : moment(z.weighReadTime).format('h:mm:ss a'),
                            'Weighment Operator': z.sOperatorName == null ? '-' : z.sOperatorName,
                            'Package Number': z.pTagNumber == null ? '-' : z.pTagNumber,
                            'Packed Time': new Date(z.packedDate).getFullYear() == 1 ? '-' : moment(z.packedDate).format('h:mm:ss a'),
                            'Package Operator': z.pOperatorName == null ? '-' : z.pOperatorName,
                            'GTN Number': z.gtnNumber == null ? '-' : z.gtnNumber,
                            'Vehicle Number': z.vehicleNumber == null ? '-' : z.vehicleNumber,
                            'GTON Time': new Date(z.gtnDate).getFullYear() == 1 ? '-' : moment(z.gtnDate).format('h:mm:ss a'),
                            'GTON Operator': z.vehicleNumber == null ? '-' : z.gtOperatorName,
                            'FDC Approval': z.isApproved == true ? "VPU Approved" : '-',
                            'GTIN Time': new Date(z.grnDate).getFullYear() == 1 ? '-' : moment(z.grnDate).format('h:mm:ss a'),
                            'GTIN Operator': z.grOperatorName == null ? '-' : z.grOperatorName,

                        };
                        res.push(vr);
                    });
                });
            });

            res.push({});
            res.push({});

            // var vr = {
            //     'FCC': "Group: " + selectedSearchValues.groupID,
            //     'Product Name': "Fresh Collection Center: " + selectedSearchValues.operationEntityID,
            //     'Product Code': "Date: " + selectedSearchValues.date
            // }
            // res.push(vr);
        }
        return res;
    }

    function getSelectedDropdownValuesForReport() {
        const facName = [];
        selectedOptions.forEach(x => {
            const fildered = operationEntityList.find(y => x === y.value).label
            facName.push(fildered)
        });
        let groups = groupList.find(x => x.groupID == formik.values.groupID)
        setSelectedSearchValues({
            ...selectedSearchValues,
            groupID: groups.groupName,
            operationEntityID: facName.length == 0 ? 'All Fresh Collection Centers' : facName.map(x => x).join(','),
            date: new Date(datevalue).toLocaleDateString()
        });
    }

    const renderSelectedValue = (selected) => {
        if (selected.length === 0) {
            return '';
        } else if (selected.length === 1) {
            const option = operationEntityList.find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = operationEntityList.find((entity) => entity.value === value);
                    return option ? <Chip label={option.label} /> : null;
                } else {
                    const option = operationEntityList.find((entity) => entity.value === value);
                    return option ? <Chip key={index} label={option.label} /> : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    return (
        <>
            <LoadingComponent />
            <Page title="FCC Activity Report  |  FAPS">
                <Container maxWidth>
                    <CommonPageHeader pageName={pageProps.pageheadername} leftButtonHidden={true} />
                    <FormikProvider value={formik}>
                        <ToastContainer position="bottom-right" pauseOnHover />
                        <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Group</MenuItem>
                                        {groupList.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                    <FormControl fullWidth error={Boolean(touched.operationEntityID && errors.operationEntityID)}>
                                        <InputLabel id="multi-select-label">Fresh Collection Center *</InputLabel>
                                        <Select
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedOptions}
                                            onChange={handleSelectChange}
                                            label="Fresh Collection Center *"
                                            renderValue={(selected) => renderSelectedValue(selected)}
                                            disabled={!permissionList.isFactoryFilterEnabled}
                                        >
                                            <MenuItem key={0} value={''}>
                                                <Checkbox checked={selectedOptions.length === operationEntityList.length} color="primary" />
                                                All Fresh Collection Center
                                            </MenuItem>
                                            {operationEntityList.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedOptions.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.operationEntityID && errors.operationEntityID && (
                                            <FormHelperText>{errors.operationEntityID}</FormHelperText>
                                        )}
                                        {selectedOptions.length > 0 && (
                                            <IconButton onClick={handleClearSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                {!permissionList.isFactoryFilterEnabled ? null :
                                                    <ClearIcon />}
                                            </IconButton>
                                        )}
                                    </FormControl>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                            fullWidth
                                            size="small"
                                            label="Date *"
                                            openTo="day"
                                            type="date"
                                            inputFormat="MM/DD/YYYY"
                                            value={datevalue}
                                            onChange={(newValue) => {
                                                setDateValue(newValue);
                                            }}
                                            maxDate={new Date()}
                                            renderInput={(params) =>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    {...params}
                                                />}
                                        />
                                    </LocalizationProvider>
                                </Stack>
                                <br />
                                <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                    <Button type="button" variant="outlined" color="error"
                                        onClick={() => clearAll()}
                                    >
                                        Clear
                                    </Button>
                                    <Button type="submit" color="secondary" variant="outlined"
                                    >
                                        Search
                                    </Button>
                                </Stack>
                                <br />
                                {isEnable == false ?
                                    <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginBottom: '10px' }} justifyContent="right" spacing={2}>
                                        <TextField
                                            size="small"
                                            style={{ width: '300px' }}
                                            value={cropData.farmerName}
                                            placeholder="Search"
                                            onChange={(e) => { handleChange(e) }}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <Search />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </Stack> : null}
                                {vccOrderDetails.length != 0 ?
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        <TableContainer component={Paper} sx={{ maxHeight: 550 }}>
                                            <Table aria-label="simple table" size='small'>
                                                <TableBody>
                                                    {vccOrderDetails.map((order) => (
                                                        <React.Fragment key={order.performOrderID}>
                                                            <TableRow>
                                                                <TableCell sx={{ border: "2px solid black", fontWeight: "bold", minWidth: '10rem' }} align="left">FCC</TableCell>
                                                                <TableCell sx={{ border: "2px solid black", fontWeight: "bold", minWidth: '10rem' }} align="left">Product</TableCell>
                                                                <TableCell sx={{ border: "2px solid black", fontWeight: "bold", minWidth: '8rem' }} align="left">Product Code</TableCell>
                                                                <TableCell sx={{ border: "2px solid black", fontWeight: "bold", minWidth: '8rem' }} align="left">Realized Price</TableCell>
                                                                <TableCell sx={{ border: "2px solid black", fontWeight: "bold", minWidth: '9rem' }} align="right">Requested Qty</TableCell>
                                                                <TableCell sx={{ border: "2px solid black", fontWeight: "bold", minWidth: '8rem' }} align="right">Accepted Qty</TableCell>
                                                                <TableCell sx={{ border: "2px solid black", fontWeight: "bold", minWidth: '10rem' }} align="right">Remaining Qty</TableCell>
                                                                <TableCell sx={{ border: "2px solid black", fontWeight: "bold", minWidth: '8rem' }} align="right">Returned Qty</TableCell>
                                                            </TableRow>
                                                            <TableRow >
                                                                <TableCell sx={{ border: "2px solid black" }} align="left">{order.orderReport.collectionCenter}</TableCell>
                                                                <TableCell sx={{ border: "2px solid black" }} align="left">{order.orderReport.productName}</TableCell>
                                                                <TableCell sx={{ border: "2px solid black" }} align="left">{order.orderReport.productCode}</TableCell>
                                                                <TableCell sx={{ border: "2px solid black" }} align="right">{order.orderReport.realizedPrice.toFixed(2)}</TableCell>
                                                                <TableCell sx={{ border: "2px solid black" }} align="right">{order.orderReport.quantity.toFixed(2)}</TableCell>
                                                                <TableCell sx={{ border: "2px solid black" }} align="right">{order.orderReport.acceptedQuantity == 0 ? '-' : order.orderReport.acceptedQuantity.toFixed(2)}</TableCell>
                                                                <TableCell sx={{ border: "2px solid black" }} align="right">{order.orderReport.reaminingQuantity == 0 ? '-' : order.orderReport.reaminingQuantity.toFixed(2)}</TableCell>
                                                                <TableCell sx={{ border: "2px solid black" }} align="right">{order.orderReport.returnQuantity == 0 ? '-' : order.orderReport.returnQuantity.toFixed(2)}</TableCell>
                                                            </TableRow>
                                                            {order.farmers.length > 0 ?
                                                                <>
                                                                    <TableRow>
                                                                        <TableCell colSpan={5} align="center" style={{ border: "2px solid black", backgroundColor: '#6ee098' }}><strong>Accepted Details</strong></TableCell>
                                                                        <TableCell colSpan={9} align="center" style={{ border: "2px solid black", backgroundColor: '#FFF366' }}><strong>Weighment Details</strong></TableCell>
                                                                        <TableCell colSpan={3} align="center" style={{ border: "2px solid black", backgroundColor: '#E7CC9B' }}><strong>Package Details</strong></TableCell>
                                                                        <TableCell colSpan={4} align="center" style={{ border: "2px solid black", backgroundColor: '#4db9f0' }}><strong>GTON Details</strong></TableCell>
                                                                        <TableCell colSpan={3} align="center" style={{ border: "2px solid black", backgroundColor: '#FFC3A5' }}><strong>GTIN Details</strong></TableCell>
                                                                    </TableRow>
                                                                    <TableRow>
                                                                        <TableCell sx={{ border: "2px solid black" }} align="Left"><strong>Farmer</strong></TableCell>
                                                                        <TableCell sx={{ border: "2px solid black" }} align="Left"><strong>Crop Variety</strong></TableCell>
                                                                        <TableCell sx={{ border: "2px solid black" }} align="right"><strong>Quantity</strong></TableCell>
                                                                        <TableCell sx={{ border: "2px solid black" }} align="Left"><strong>Accepted Time</strong></TableCell>
                                                                        <TableCell sx={{ border: "2px solid black" }} align="Left"><strong>Operator</strong></TableCell>
                                                                        <TableCell sx={{ border: "2px solid black" }} align="Left"><strong>Tag Number</strong></TableCell>
                                                                        <TableCell sx={{ border: "2px solid black" }} align="Left"><strong>Tag Count</strong></TableCell>
                                                                        <TableCell sx={{ border: "2px solid black" }} align="right"><strong>Actual Qty</strong></TableCell>
                                                                        <TableCell sx={{ border: "2px solid black", minWidth: '7rem' }} align="right"><strong>Gross Qty</strong></TableCell>
                                                                        <TableCell sx={{ border: "2px solid black", minWidth: '6rem' }} align="right"><strong>Deduction</strong></TableCell>
                                                                        <TableCell sx={{ border: "2px solid black", minWidth: '6rem' }} align="right"><strong>Net Qty</strong></TableCell>
                                                                        <TableCell sx={{ border: "2px solid black", minWidth: '6rem' }} align="right"><strong>Total Qty</strong></TableCell>
                                                                        <TableCell sx={{ border: "2px solid black", minWidth: '8rem' }} align="Left"><strong>Weighment Time</strong></TableCell>
                                                                        <TableCell sx={{ border: "2px solid black", minWidth: '8rem' }} align="Left"><strong>Operator</strong></TableCell>
                                                                        <TableCell sx={{ border: "2px solid black", minWidth: '8rem' }} align="Left"><strong>Package Number</strong></TableCell>
                                                                        <TableCell sx={{ border: "2px solid black", minWidth: '8rem' }} align="Left"><strong>Packed Time</strong></TableCell>
                                                                        <TableCell sx={{ border: "2px solid black", minWidth: '8rem' }} align="Left"><strong>Operator</strong></TableCell>
                                                                        <TableCell sx={{ border: "2px solid black", minWidth: '8rem' }} align="Left"><strong>GTN Number</strong></TableCell>
                                                                        <TableCell sx={{ border: "2px solid black", minWidth: '8rem' }} align="Left"><strong>Vehicle Number</strong></TableCell>
                                                                        <TableCell sx={{ border: "2px solid black", minWidth: '8rem' }} align="Left"><strong>GTON Time</strong></TableCell>
                                                                        <TableCell sx={{ border: "2px solid black", minWidth: '8rem' }} align="Left"><strong>Operator</strong></TableCell>
                                                                        <TableCell sx={{ border: "2px solid black", minWidth: '9rem' }} align="Left"><strong>FDC Approval</strong></TableCell>
                                                                        <TableCell sx={{ border: "2px solid black", minWidth: '12rem' }} align="Left"><strong>GTIN Time</strong></TableCell>
                                                                        <TableCell sx={{ border: "2px solid black", minWidth: '8rem' }} align="Left"><strong>Operator</strong></TableCell>
                                                                    </TableRow>
                                                                    {order.farmers.map((farmer, index) => (
                                                                        <>
                                                                            <TableRow>
                                                                                <TableCell sx={{ border: "2px solid black" }} rowSpan={farmer.details.length} align="Left">{farmer.farmerName}</TableCell>
                                                                                <TableCell sx={{ border: "2px solid black" }} rowSpan={farmer.details.length} align="Left">{farmer.varietyName}</TableCell>
                                                                                <TableCell sx={{ border: "2px solid black" }} rowSpan={farmer.details.length} align="right">{farmer.farmerQuantity.toFixed(2)}</TableCell>
                                                                                <TableCell sx={{ border: "2px solid black" }} rowSpan={farmer.details.length} align="Left">{moment(farmer.acceptedDate).format('h:mm:ss a')}</TableCell>
                                                                                <TableCell sx={{ border: "2px solid black" }} rowSpan={farmer.details.length} align="Left">{farmer.operatorName}</TableCell>
                                                                                {farmer.details.map((res, index) => {
                                                                                    if (index == 0) {
                                                                                        return (
                                                                                            <>
                                                                                                <TableCell sx={{ border: "2px solid black" }} align="Left">{res.tagNumber == null ? '-' : res.tagNumber}</TableCell>
                                                                                                <TableCell sx={{ border: "2px solid black" }} align="right">{res.tagCount == 0 ? '-' : res.tagCount}</TableCell>
                                                                                                <TableCell sx={{ border: "2px solid black" }} align="right">{res.actualAmount == 0 ? '-' : res.actualAmount.toFixed(2)}</TableCell>
                                                                                                <TableCell sx={{ border: "2px solid black" }} align="right">{res.grossAmount == 0 ? '-' : res.grossAmount.toFixed(2)}</TableCell>
                                                                                                <TableCell sx={{ border: "2px solid black" }} align="right">{res.deduction == 0 ? '-' : res.deduction.toFixed(2)}</TableCell>
                                                                                                <TableCell sx={{ border: "2px solid black" }} align="right">{res.netAmount == 0 ? '-' : res.netAmount.toFixed(2)}</TableCell>
                                                                                                <TableCell sx={{ border: "2px solid black" }} align="right">{res.totalAmount == 0 ? '-' : res.totalAmount.toFixed(2)}</TableCell>
                                                                                                <TableCell sx={{ border: "2px solid black" }} align="Left">
                                                                                                    {new Date(res.weighReadTime).getFullYear() == 1 ? '-' : moment(res.weighReadTime).format('h:mm:ss a')}
                                                                                                </TableCell>
                                                                                                <TableCell sx={{ border: "2px solid black" }} align="Left">{res.sOperatorName == null ? '-' : res.sOperatorName}</TableCell>
                                                                                                <TableCell sx={{ border: "2px solid black" }} align="Left">{res.pTagNumber == null ? '-' : res.pTagNumber}</TableCell>
                                                                                                <TableCell sx={{ border: "2px solid black" }} align="Left">
                                                                                                    {new Date(res.packedDate).getFullYear() == 1 ? '-' : moment(res.packedDate).format('h:mm:ss a')}
                                                                                                </TableCell>
                                                                                                <TableCell sx={{ border: "2px solid black" }} align="Left">{res.pOperatorName == null ? '-' : res.pOperatorName}</TableCell>
                                                                                                <TableCell sx={{ border: "2px solid black" }} align="Left">{res.gtnNumber == null ? '-' : res.gtnNumber}</TableCell>
                                                                                                <TableCell sx={{ border: "2px solid black" }} align="Left">{res.vehicleNumber == null ? '-' : res.vehicleNumber}</TableCell>
                                                                                                <TableCell sx={{ border: "2px solid black" }} align="Left">
                                                                                                    {new Date(res.gtnDate).getFullYear() == 1 ? '-' : moment(res.gtnDate).format('h:mm:ss a')}
                                                                                                </TableCell>
                                                                                                <TableCell sx={{ border: "2px solid black" }} align="Left">{res.gtOperatorName == null ? '-' : res.gtOperatorName}</TableCell>
                                                                                                <TableCell sx={{ border: "2px solid black" }} align="Left">
                                                                                                    {res.isApproved == true ? <Chip label="VPU Approved" variant="outlined" color='success' /> : '-'}
                                                                                                </TableCell>
                                                                                                <TableCell sx={{ border: "2px solid black" }} align="Left">
                                                                                                    {res.isApproved == true ? new Date(res.grnDate).getFullYear() == 1 ? '-' : moment(res.grnDate).format('YYYY-MM-DD/h:mm:ss a') : '-'}
                                                                                                </TableCell>
                                                                                                <TableCell sx={{ border: "2px solid black" }} align="Left">
                                                                                                    {res.isApproved == true ? res.grOperatorName == null ? '-' : res.grOperatorName : '-'}
                                                                                                </TableCell>
                                                                                            </>
                                                                                        )
                                                                                    }
                                                                                })}
                                                                            </TableRow>
                                                                            <>
                                                                                {farmer.details.map((res, index) => {
                                                                                    if (index != 0) {
                                                                                        return (
                                                                                            <TableRow>
                                                                                                <TableCell sx={{ border: "2px solid black" }} align="Left">{res.tagNumber == null ? '-' : res.tagNumber}</TableCell>
                                                                                                <TableCell sx={{ border: "2px solid black" }} align="right">{res.tagCount == 0 ? '-' : res.tagCount}</TableCell>
                                                                                                <TableCell sx={{ border: "2px solid black" }} align="right">{res.actualAmount == 0 ? '-' : res.actualAmount.toFixed(2)}</TableCell>
                                                                                                <TableCell sx={{ border: "2px solid black" }} align="right">{res.grossAmount == 0 ? '-' : res.grossAmount.toFixed(2)}</TableCell>
                                                                                                <TableCell sx={{ border: "2px solid black" }} align="right">{res.deduction == 0 ? '-' : res.deduction.toFixed(2)}</TableCell>
                                                                                                <TableCell sx={{ border: "2px solid black" }} align="right">{res.netAmount == 0 ? '-' : res.netAmount.toFixed(2)}</TableCell>
                                                                                                <TableCell sx={{ border: "2px solid black" }} align="right">{res.totalAmount == 0 ? '-' : res.totalAmount.toFixed(2)}</TableCell>
                                                                                                <TableCell sx={{ border: "2px solid black" }} align="Left">
                                                                                                    {new Date(res.weighReadTime).getFullYear() == 1 ? '-' : moment(res.weighReadTime).format('h:mm:ss a')}
                                                                                                </TableCell>
                                                                                                <TableCell sx={{ border: "2px solid black" }} align="Left">{res.sOperatorName == null ? '-' : res.sOperatorName}</TableCell>
                                                                                                <TableCell sx={{ border: "2px solid black" }} align="Left">{res.pTagNumber == null ? '-' : res.pTagNumber}</TableCell>
                                                                                                <TableCell sx={{ border: "2px solid black" }} align="Left">
                                                                                                    {new Date(res.packedDate).getFullYear() == 1 ? '-' : moment(res.packedDate).format('h:mm:ss a')}
                                                                                                </TableCell>
                                                                                                <TableCell sx={{ border: "2px solid black" }} align="Left">{res.pOperatorName == null ? '-' : res.pOperatorName}</TableCell>
                                                                                                <TableCell sx={{ border: "2px solid black" }} align="Left">{res.gtnNumber == null ? '-' : res.gtnNumber}</TableCell>
                                                                                                <TableCell sx={{ border: "2px solid black" }} align="Left">{res.vehicleNumber == null ? '-' : res.vehicleNumber}</TableCell>
                                                                                                <TableCell sx={{ border: "2px solid black" }} align="Left">
                                                                                                    {new Date(res.gtnDate).getFullYear() == 1 ? '-' : moment(res.gtnDate).format('h:mm:ss a')}
                                                                                                </TableCell>
                                                                                                <TableCell sx={{ border: "2px solid black" }} align="Left">{res.gtOperatorName == null ? '-' : res.gtOperatorName}</TableCell>
                                                                                                <TableCell sx={{ border: "2px solid black" }} align="Left">
                                                                                                    {res.isApproved == true ? <Chip label="VPU Approved" variant="outlined" color='success' /> : '-'}
                                                                                                </TableCell>
                                                                                                <TableCell sx={{ border: "2px solid black" }} align="Left">
                                                                                                    {res.isApproved == true ? new Date(res.grnDate).getFullYear() == 1 ? '-' : moment(res.grnDate).format('YYYY-MM-DD/h:mm:ss a') : '-'}
                                                                                                </TableCell>
                                                                                                <TableCell sx={{ border: "2px solid black" }} align="Left">
                                                                                                    {res.isApproved == true ? res.grOperatorName == null ? '-' : res.grOperatorName : '-'}
                                                                                                </TableCell>
                                                                                            </TableRow>
                                                                                        )
                                                                                    }
                                                                                })}
                                                                            </>
                                                                        </>
                                                                    ))}
                                                                    <br />
                                                                </>
                                                                :
                                                                <>
                                                                    <TableRow>
                                                                        <TableCell sx={{ border: "2px solid black" }} colSpan={6} align="center">
                                                                            <Typography variant="h7" gutterBottom component="div">
                                                                                <b>No Accepted Details</b>
                                                                            </Typography>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                    <br />
                                                                </>}
                                                        </React.Fragment>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Stack> : <SearchNotFound searchQuery="FCC Activity Details" />}
                            </Stack>
                        </Form>
                    </FormikProvider>
                    {vccOrderDetails.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorRecord}
                                onClick={() => createFile()}
                            >
                                EXCEL
                            </Button>
                            <ReactToPrint
                                documentTitle={"FCC Activity Report"}
                                trigger={() => <Button
                                    color="primary"
                                    id="btnRecord"
                                    type="submit"
                                    variant="contained"
                                    style={{ marginRight: '1rem', backgroundColor: 'red' }}
                                    className={classes.colorCancel}
                                >
                                    PDF
                                </Button>}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePDF ref={componentRef}
                                    vccOrderDetails={vccOrderDetails}
                                    searchData={selectedSearchValues}

                                />
                            </div>
                        </Box> : null}
                </Container>
            </Page>
        </>
    );
}